import { css } from '@emotion/react';
import { flex } from '@spotnana/blocks/src/utils';
import { spacings } from '@spotnana/blocks/src/utils/styling/utilityTokens';

export const fare_list_container = css`
  ${flex.init}
  ${flex.column}
  ${spacings.medium}
`;
